import { NavLink } from "react-router-dom";

const menuList = [
  {
    label: "Dashboard",
    icon: "dashboard-2-line",
    path: "/dashboard",
  },
  {
    label: "Listings / Properties",
    icon: "community-line",
    path: "/properties",
  },
  {
    label: "Leads",
    icon: "contacts-book-2-line",
    path: "/leads",
  },
  {
    label: "Tasks & Reminders",
    icon: "list-check-3",
    path: "/tasks/list",
  },
  {
    label: "Contacts",
    icon: "contacts-book-3-line",
    path: "/contacts",
  },
  {
    label: "Agents",
    icon: "group-line",
    path: "/agents",
  },
  {
    label: "Team",
    icon: "team-line",
    path: "/team",
  },
  {
    label: "Calendar & Appointments",
    icon: "calendar-2-line",
    path: "/calendar-appointments",
  },
  {
    label: "Deals / Transactions",
    icon: "home-office-line",
    path: "/deals-transactions",
  },
  {
    label: "Marketing & Campaigns",
    icon: "store-line",
    path: "/campaigns",
  },
  {
    label: "Client Portal",
    icon: "home-office-line",
    path: "/client-portal",
  },
  {
    label: "Reports & Analytics",
    icon: "folder-chart-line",
    path: "/reports",
  },
  {
    label: "Document Center",
    icon: "inbox-line",
    path: "/document-center",
  },

  {
    label: "Settings & Integrations",
    icon: "settings-3-line",
    path: "/settings",
  },
  {
    label: "Help & Support",
    icon: "questionnaire-line",
    path: "/help-and-support",
  },
];

const Sidebar = ({ onLogout }) => {
  const onToogleMenu = () => {
    const element = document.getElementById("toogleBoby");
    element.classList.toggle("sidebar-enable");
    if (element.classList.contains("sidebar-enable")) {
      element.setAttribute("data-menu-size", "condensed");
    } else {
      element.setAttribute("data-menu-size", "default");
    }
  };
  return (
    <div className="main-nav">
      <button type="button" className="button-toggle-menu topbar-button" onClick={onToogleMenu}>
        <i className="ri-menu-2-line fs-28"></i>
      </button>
      <div className="scrollbar" data-simplebar>
        <ul className="navbar-nav" id="navbar-nav">
          {menuList.map((item, idx) => (
            <li key={idx} className="nav-item">
              <NavLink to={item.path} className="nav-link">
                <span className="nav-icon">
                  <i className={`ri-${item.icon}`}></i>
                </span>
                {/* <em>{item.label}</em> */}
                <span className="nav-text">{item.label}</span>
              </NavLink>
            </li>
          ))}

          <li className="nav-item">
            <button className="nav-link" type="button" onClick={onLogout}>
              <span className="nav-icon">
                <i className="ri-logout-box-line"></i>
              </span>
              <span className="nav-text">Logout</span>
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
